import { UserSecuritySettingModel } from './userSecuritySettingModel';

export class AddorEditUserSecuritySettingModel extends UserSecuritySettingModel {
}
